import React, { Component } from 'react';
import { get, has } from "lodash"

import { withStepsState } from "../../../shared/containers/containerStepsState"

import FirstTitle from '../../../shared/items/static/firstTitle';
import RadioCheckButton from '../../../shared/items/controls/radioCheckButton';
import { isCurrentStep, buildStepClassName, updateOpenStepState } from "../../../shared/services/service.step"
import CurrentActivityNextStepButton from "./currentActivityNextStepButton"
import { currentActivityData } from "./static.currentActivityData"
import StepContentWrapper from "./../stepContentWrapper"
import StepControl from "./../stepControl"
import { steps } from "../../../shared/static.steps"
import locales from "./../../../content.json"
import "./../../../shared/services/service.step.scss"

class CurrentActivity extends Component {
  constructor() {
    super();

    this.state = {
      isOpenCurrentActivity: false,
    }
  }

  componentDidMount() {
    if (isCurrentStep(this.props.currentIndex, steps.currentActivity) && !this.state.isOpenCurrentActivity)
      this.setState({ isOpenCurrentActivity: true })
  }

  componentDidUpdate(prevProps) {
    const { currentIndex, data, onSetStepData } = this.props
    const { isOpenCurrentActivity } = this.state
    const params = {
      currentIndex: currentIndex,
      prevIndex: prevProps.currentIndex,
      stepIndex: steps.currentActivity,
      isOpen: isOpenCurrentActivity,
      handleChange: this.handleChangeOpen.bind(this),
    }

    if (isOpenCurrentActivity && !has(data, ["currentActivity"]))
      onSetStepData("currentActivity")

    updateOpenStepState({ params })
  }

  handleChangeOpen(state) {
    this.setState({
      isOpenCurrentActivity: state,
    })
  }

  render() {
    const { currentIndex, data, onUpdateStepData } = this.props
    const { isOpenCurrentActivity } = this.state
    const params = {
      className: "wrapperCurrentActivity",
      currentIndex: currentIndex,
      stepIndex: steps.currentActivity,
    }

    return isOpenCurrentActivity ?
      <div className={buildStepClassName({ params })}>

        <StepContentWrapper>
          <FirstTitle>{locales[window.userLang].activity_ask}</FirstTitle>

          {
            Object.keys(currentActivityData).map((key, index) => {
              return (
                <RadioCheckButton
                  key={index}
                  isChecked={get(data, ["currentActivity", "value"], null) === currentActivityData[key].value}
                  onClick={() => {
                    if (get(data, ["currentActivity", "value"], null) !== currentActivityData[key].value) {
                      onUpdateStepData.bind(this, "currentActivity", "value", currentActivityData[key].value)();
                      setTimeout(this.props.onToNextStep, 300);
                    }
                  }}
                  icon={currentActivityData[key].icon}
                >
                  {currentActivityData[key].title}
                </RadioCheckButton>
              )
            })
          }
        </StepContentWrapper>
      </div>
      : null
  }
}

export default withStepsState(CurrentActivity);